import { styled } from '@linaria/react';
import { fonts, layout, semantic, space, textStyle } from '../../theme/tokens';

export const Heading = styled.h1`
  font-family: ${textStyle.display['size-md'].fontFamily};
  font-size: ${textStyle.display['size-md'].fontSize};
  font-weight: ${textStyle.display['size-md'].fontWeight};
  line-height: ${textStyle.display['size-md'].lineHeight};
  letter-spacing: ${textStyle.display['size-md'].letterSpacing};
  color: ${semantic.text.primary};
  text-align: left;
  margin: 0 0 ${space['space-1000']};
  max-width: 100%;

  &[data-flush='true'] {
    margin-bottom: 0;
  }

  &[data-centered='true'] {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    max-width: 75%;

    &[data-flush='true'],
    &[data-fullwidth='true'] {
      max-width: 100%;
    }
  }
`;

export const Subtitle = styled.span`
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.tertiary};

  &[data-block='true'] {
    display: block;
  }
`;
